import { getTraitKind } from "./types";

export function getSuitColor(suit, inline = false) {
	switch (suit) {
		case 'none': 
			return 'white';
		case 'captain':
			return inline ? '#64603A' : 'azure';
		case 'directive':
			return inline ? 'darkgray' : '#64603A';
		case 'location':
			return 'green';
		case 'person':
			return 'goldenrod';
		case 'cargo':
			return '#004A8C';
		case 'ship':
			return 'gray';
		case 'ally':
			return 'purple';
		case 'incident':
			return 'red';
		case 'encounter':
			return 'plum';
		case 'status':
			return '#222222';
		case 'mission':
			return 'black';
		case 'qsuit':
			return 'deeppink';
	}
}

export function getTraitColor(trait) {
	switch (getTraitKind(trait)) {
		case 'utility':
			return {
				background: 'lightgray',
				label: 'black'
			};
		case 'special':
			return {
				background: 'red',
				label: 'white'
			};
		case 'species':
			return {
				background: 'darkorange',
				label: 'white'
			};
		case 'standard':
			return {
				background: 'deepskyblue',
				label: 'white'
			};
		case 'wild':
			return {
				background: 'pink',
				label: 'black'
			};
	}
}

export function getSpecialtyColor(specialty) {
	switch (specialty) {
		case 'research':
			return '#005b7f';
		case 'influence':
			return '#c1b400';
		case 'military':
			return '#ab003d';
		case 'collective':
			return '#00a650';
	}
}

// Sorting trait labels measured text on a fresh canvas for every comparison, on
// every card re-render. Reuse one context and cache widths once the font is ready.
const traitLabelWidths = new Map();
let traitLabelContext;
function getTraitLabelWidth(txt) {
	if (traitLabelWidths.has(txt)) return traitLabelWidths.get(txt);
	if (traitLabelContext === undefined) traitLabelContext = document.createElement('canvas').getContext('2d');
	const context = traitLabelContext;
	if (!context) return 0;
	context.font = '100 16px Antonio';
	const result = context.measureText(txt.toUpperCase()).width ?? 0;
	//console.log('width of', txt, 'is', result);
	// Don't cache fallback-font widths measured before Antonio has loaded
	if (!document.fonts || document.fonts.check(context.font)) traitLabelWidths.set(txt, result);
	return result;
}
export function byTraitLabelWidthSorter(a, b) {
	return getTraitLabelWidth(a) > getTraitLabelWidth(b) ? -1 : 1;
}
